import React from "react";
import Container from "react-bootstrap/Container";

function CurriculumHero({ nombre, descripcion }) {
  const lead = descripcion?.trim();
  return (
    <section className="course-detail__jumbotron">
      <Container fluid>
        <h2>{nombre}</h2>
        {lead ? <p>{lead}</p> : null}
      </Container>
    </section>
  );
}

export default CurriculumHero;
